// src/App.js
import './App.scss';
import React, {useState, useEffect} from 'react';
import {Snackbar, Alert} from '@mui/material';
import UploadForm from './components/Upload-Form/UploadForm';
import TextDisplay from './components/TextDisplay/TextDisplay.components';
import ImageGallery from './components/ImageGallery/ImageGallery.components';
import {reportMessagesTo, sessionId} from './socket';
import {Loader} from './components/Loader/loder.components';
import {scrapePdf} from './utils/apiCall';
import {uploadFile} from './utils/fileUpload';
import Navbar from './components/Navbar/Navbar.component';
function App() {
  const [scrapedText, setScrapedText] = useState('');
  const [scrapedImages, setScrapedImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [scraping, setScraping] = useState(false);
  const [notification, setNotification] = useState({open: false, message: '', severity: 'success'});
  const handleUpload = async (formData) => {
    setLoading(true);
    setScraping(true);
    setScrapedText('');
    setScrapedImages([]);
    try {
      // Upload the PDF and get the hosted URL
      const hostedUrls = await uploadFile(formData);

      const pdfUrl = hostedUrls[0]; // Assuming only one PDF is uploaded
      await scrapePdf(pdfUrl, sessionId);

      setNotification({open: true, message: 'starting to scrape the pdf!', severity: 'success'});
    } catch (error) {
      console.error(error);
      setNotification({open: true, message: 'An error occurred while processing the PDF.', severity: 'error'});
      setScraping(false);
      setLoading(false);
    }
  };

  const handleCloseNotification = () => {
    setNotification({...notification, open: false});
  };

  const receiver = ({message}) => {
    if (message && typeof message === 'object') {
      switch (message.status) {
        case 'pdfScrapingCompleted': {
          // console.log(`pdfScrapingCompleted object received`, message);
          const {scrapedImages, scrapedTexts} = message;
          setScraping(false);
          setLoading(false);
          setScrapedText(scrapedTexts);
          setScrapedImages(scrapedImages);
          break;
        }
        case 'error':
          // console.log('ERROR: receiver: error message:', message);
          const {erroMessage} = message;
          setScraping(false);
          setLoading(false);
          return setNotification({open: true, message: `An error occurred while processing the PDF,${erroMessage}`, severity: 'error'});

        default:
          setLoading(false);
          setScraping(false);
          // console.log(`Unrecognized message object from socket: `, message);
          setNotification({open: true, message: 'An unexpected error happened, please try again', severity: 'error'});
          break;
      }
    } else {
      //setBack to true after message comes back
      // console.log(`message string from socket: ${message}`);
    }
  };

  useEffect(() => {
    // This function will run exactly once after the component is mounted
    // Tell the socket code where to send the messages.
    const runOnceFunction = () => {
      // console.log('runOnceFunction: setting receiver');
      reportMessagesTo({receiver});
    };
    runOnceFunction();
  }, []); // Empty dependency a

  return (
    <div>
      <Navbar />
      <div className="page-container">
        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'ceter', justifyContent: 'space-around', width: '30vw'}}>
          <h1 className="main-h1">Pdf-Scraper</h1>
          <UploadForm onUpload={handleUpload} loading={loading} />
        </div>

        <div className="content-box">
          {scraping && <Loader />}
          {scrapedText && <TextDisplay text={scrapedText} />}
          {scrapedImages.length > 0 && <ImageGallery images={scrapedImages} setLoading={setLoading} loading={loading} />}
        </div>
        <Snackbar open={notification.open} autoHideDuration={6000} onClose={handleCloseNotification}>
          <Alert onClose={handleCloseNotification} severity={notification.severity} sx={{width: '100%'}}>
            {notification.message}
          </Alert>
        </Snackbar>
      </div>
    </div>
  );
}

export default App;
